@if (viewModel(); as vm) {
  @switch (variant()) {
    @case ('overlay') {
      <div class="fipe-diff-container">
        <div class="fipe-logo"></div>
        <p [style.color]="color()">
          {{ vm.text }}
        </p>
      </div>
    }
    @case ('tag') {
      <div class="fipe-percentage-tag" [style.color]="color()" [class]="cssClass()">
        {{ vm.text }}
        @if (displaySuffix()) {
          <span class="fipe-label">{{ displaySuffix() }}</span>
        }
      </div>
    }
    @default {
      <div [style.color]="color()" [class]="cssClass()">
        {{ vm.text }}@if (displaySuffix()) { {{ ' ' + displaySuffix() }} }
      </div>
    }
  }
}
